module.exports = __webpack_public_path__ + "static/seznam-bba51bd958107c959526a0847b3ee2c0.png";